import { APP_CONTEXT, getAppContext } from 'utils/app-context';
import { userRoles, userRolesNames, userTypes } from 'utils/constants';
import toTitleCase from 'utils/title-case';

const isResiPropertyRole = role =>
    role === userRoles.RESIDENT || role === userRoles.TENANT;

// A role or type key as people read it: the platform name, or the key itself made readable.
const nameOf = key => (key ? userRolesNames[key] || toTitleCase(key) : '');

// What the user is in the active org: their type there.
const orgLabel = userData => nameOf(userData.orgs?.[userData.active_org_id]?.type);

// What the user is on the active property: Resident / Tenant on a resident one, their type on an
// operator one.
const propertyLabel = userData => {
    const property = userData.properties?.[userData.active_property_id];

    if (!property) return '';
    if (isResiPropertyRole(property.role)) return userRolesNames[property.role];

    return nameOf(property.type || property.role);
};

// The role shown under the user's name. The active side decides which record is read first: the
// org in the operator app, the property in the resident one. The root type / role of the user
// document is the last resort.
export const getRoleLabel = userData => {
    if (!userData) return '';
    if (userData.type === userTypes.SUPER_ADMIN) return userRolesNames.super_admin;

    const labels =
        getAppContext(userData) === APP_CONTEXT.RESI
            ? [propertyLabel(userData), orgLabel(userData)]
            : [orgLabel(userData), propertyLabel(userData)];

    return labels.find(Boolean) || nameOf(userData.type) || nameOf(userData.role);
};
